import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import { useCart }
from "../context/CartContext";

import {
  ToastContainer,
  toast
} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import Header
from "../components/Header";

import config
from "../config";

const PRODUCT_API =
  `${config.API_BASE_URL}/api/products`;

const CATEGORY_API =
  `${config.API_BASE_URL}/api/categories`;

const Products = () => {

  const navigate =
    useNavigate();

  const { categoryId } =
    useParams();

  const {
    addToCart,
    cart
  } = useCart();

  // =========================
  // STATES
  // =========================

  const [products, setProducts] =
    useState([]);

  const [
    filteredProducts,
    setFilteredProducts
  ] = useState([]);

  const [categories, setCategories] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [search, setSearch] =
    useState("");

  const [addedId, setAddedId] =
    useState(null);

  const [selectedCarats, setSelectedCarats] =
  useState({});
  // =========================
  // LOAD PRODUCTS
  // =========================

  const loadProducts =
    async () => {

    try {

      setLoading(true);

      let url =
        PRODUCT_API;

      // CATEGORY FILTER
      if (categoryId) {

        url +=
          `?categoryid=${categoryId}`;
      }

      const res =
        await axios.get(url);

      const data =
        res.data.data || [];

      setProducts(data);

      setFilteredProducts(data);

    } catch (err) {

      console.error(
        "LOAD PRODUCTS ERROR:",
        err
      );

      toast.error(
        "Failed to load products"
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================
  // LOAD CATEGORIES
  // =========================

  const loadCategories =
    async () => {

    try {

      const res =
        await axios.get(
          CATEGORY_API
        );

      setCategories(
        res.data.data || []
      );

    } catch (err) {

      console.error(
        "CATEGORY LOAD ERROR:",
        err
      );
    }
  };

  useEffect(() => {

    loadProducts();

    loadCategories();

  }, [categoryId]);

  // =========================
  // SEARCH FILTER
  // =========================

  useEffect(() => {

    const filtered =
      products.filter((p) => {

        const name = (
          p.name ||
          p.Name ||
          ""
        ).toLowerCase();

        return name.includes(
          search.toLowerCase()
        );
      });

    setFilteredProducts(filtered);

  }, [search, products]);

  // =========================
  // ADD TO CART
  // =========================

  const handleAddToCart = (product, e) => {

  e.stopPropagation();

  const id =
    product.id || product.Id;

  const alreadyInCart =
    cart.some(
      (item) =>
        (item.id || item.Id) === id
    );

  if (alreadyInCart) {

    toast.warning(
      "Already added to cart!"
    );

    return;
  }

  const selectedCarat =
    selectedCarats[id] || 1;

  const cartProduct = {
    ...product,
    qty: selectedCarat
  };

  addToCart(cartProduct);

  toast.success(
    `${selectedCarat} Crt added`
  );
};
const getUnit = (product) => {

  const categoryId =
    product.categoryid ||
    product.CategoryId;

  return Number(categoryId) === 1
    ? "Crt"
    : "Qty";
};
  return (

    <div style={styles.page}>

      <Header />

      <ToastContainer />

      {/* =========================
          HEADER
      ========================= */}

      <div style={styles.header}>

        <div>

          <h1 style={styles.title}>
            🛍 Products
          </h1>

          <p style={styles.subtitle}>
            Explore premium spiritual &
            lifestyle products
          </p>

        </div>

        <button
          style={styles.cartBtn}
          onClick={() =>
            navigate("/cart")
          }
        >
          🛒 Cart ({cart.length})
        </button>

      </div>

      {/* =========================
          CATEGORY FILTER
          ========================= */}

<div style={styles.categoryWrap}>

  <button
    style={{
      ...styles.categoryBtn,
      background:
        !categoryId
          ? "#ff9800"
          : "#fff",

      color:
        !categoryId
          ? "#fff"
          : "#333",

      border:
        !categoryId
          ? "2px solid #ff9800"
          : "2px solid #ddd"
    }}
    onClick={() =>
      navigate("/products")
    }
  >
    All
  </button>

  {categories.map((cat) => {

    const active =
      String(categoryId) ===
      String(cat.id);

    return (

      <button
        key={cat.id}
        style={{
          ...styles.categoryBtn,

          background:
            active
              ? "#ff9800"
              : "#fff",

          color:
            active
              ? "#fff"
              : "#333",

          border:
            active
              ? "2px solid #ff9800"
              : "2px solid #ddd",

          boxShadow:
            active
              ? "0 4px 12px rgba(255,152,0,0.35)"
              : "0 2px 6px rgba(0,0,0,0.05)"
        }}
        onClick={() =>
          navigate(
            `/products/category/${cat.id}`
          )
        }
      >
        {cat.name}
      </button>

    );
  })}

</div>

      {/* =========================
          SEARCH
      ========================= */}

      <div style={styles.searchSection}>

        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
          style={styles.searchInput}
        />

      </div>

      {/* =========================
          LOADING
      ========================= */}

      {loading ? (

        <div style={styles.loadingBox}>
          Loading products...
        </div>

      ) : filteredProducts.length === 0 ? (

        <div style={styles.emptyBox}>
          No products found
        </div>

      ) : (

        <div style={styles.grid}>

          {filteredProducts.map((p) => {

            const id =
              p.id || p.Id;

            const name =
              p.name ||
              p.Name ||
              "Unnamed Product";

            const image =
              p.image ||
              p.Image;

            const price = Number(
              p.price ||
              p.Price ||
              0
            );

            const stock = Number(
              p.stock ||
              p.Stock ||
              0
            );

            return (

              <div
                key={id}
                style={styles.card}
                onClick={() =>
                  navigate(
                    `/product/${id}`
                  )
                }
              >

                {/* IMAGE */}

                <div style={styles.imageWrap}>

                  {image ? (

                    <img
                      src={`${config.API_BASE_URL}/uploads/${image}`}
                      alt={name}
                      style={styles.image}
                    />

                  ) : (

                    <div style={styles.noImage}>
                      No Image
                    </div>

                  )}

                </div>

                {/* INFO */}

                <div style={styles.info}>

                  <h3 style={styles.productName}>
                    {name}
                  </h3>

                  <div style={styles.categoryText}>
                    {p.categoryname || "General"}
                  </div>

                  <div style={styles.price}>
                    ₹{price.toFixed(2)} / {getUnit(p)}
                  </div>
<div
  style={{
    fontWeight: "bold",
    color: "#28a745",
    marginBottom: 10
  }}
>
  Total:
  ₹
  {(
    price *
    (selectedCarats[id] || 1)
  ).toLocaleString()}
</div>
<div style={{ marginBottom: 12 }}>

  <label
    style={{
      display: "block",
      marginBottom: 5,
      fontWeight: "bold",
      fontSize: 13
    }}
  >
    {getUnit(p)}
  </label>

  <input
    type="number"
    min="1"
    value={
      selectedCarats[id] || 1
    }
    onClick={(e) =>
      e.stopPropagation()
    }
    onChange={(e) =>
      setSelectedCarats({
        ...selectedCarats,
        [id]:
          parseInt(
            e.target.value
          ) || 1
      })
    }
    style={{
      width: "100%",
      padding: "8px",
      borderRadius: "8px",
      border:
        "1px solid #ddd"
    }}
  />

</div>

                  <div
                    style={{
                      ...styles.stock,
                      color:
                        stock > 0
                          ? "#28a745"
                          : "#dc3545"
                    }}
                  >
                    {stock > 0
                      ? `${stock} In Stock`
                      : "Out of Stock"}
                  </div>

                </div>

                {/* BUTTON */}

                <div style={styles.buttonContainer}>

  <button
    disabled={stock <= 0}
    onClick={(e) =>
      handleAddToCart(
        p,
        e
      )
    }
    style={{
      ...styles.addBtn,

      background:
        stock <= 0
          ? "#999"
          : addedId === id
          ? "#17a2b8"
          : "#ff9800"
    }}
  >
    {stock <= 0
      ? "Out Of Stock"
      : addedId === id
      ? "✔ Added"
      : "🛒 Add To Cart"}
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();

      openWhatsApp(
        name,
        price
      );
    }}
    style={styles.whatsappBtn}
  >
    💬 WhatsApp Enquiry
  </button>

</div>

              </div>
            );
          })}

        </div>
      )}

    </div>
  );
};
const openWhatsApp = (productName, price) => {

  const message = encodeURIComponent(
`Namaste Tuli Ji 🙏
I would like to know more about this product:
Product: ${productName}
Price: ₹${price}
Please guide me.
Thank you.`
  );

  window.open(
    `https://wa.me/916290140351?text=${message}`,
    "_blank"
  );
};

export default Products;

// =========================
// STYLES
// =========================

const styles = {
  

  page: {
    minHeight: "100vh",
    background: "#f5f7fb",
    padding: 20
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 15,
    marginBottom: 25
  },

  title: {
    margin: 0,
    fontSize: 34,
    fontWeight: "bold",
    color: "#222"
  },

  subtitle: {
    marginTop: 5,
    color: "#666",
    fontSize: 15
  },

  categoryWrap: {
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
  marginBottom: 25,
  padding: "10px 0"
},

categoryBtn: {
  background: "#fff",
  border: "2px solid #ddd",
  padding: "10px 18px",
  borderRadius: 30,
  cursor: "pointer",
  fontWeight: "600",
  fontSize: 14,
  transition: "all 0.25s ease"
},

  // categoryBtn: {
  //   background: "#fff",
  //   border: "1px solid #ddd",
  //   padding: "10px 16px",
  //   borderRadius: 30,
  //   cursor: "pointer",
  //   fontWeight: "bold"
  // },

  searchSection: {
    marginBottom: 25
  },

  searchInput: {
    width: "100%",
    maxWidth: 420,
    padding: 14,
    borderRadius: 10,
    border: "1px solid #ddd",
    outline: "none",
    fontSize: 15,
    background: "#fff"
  },

  loadingBox: {
    background: "#fff",
    padding: 40,
    borderRadius: 12,
    textAlign: "center",
    fontSize: 18
  },

  emptyBox: {
    background: "#fff",
    padding: 40,
    borderRadius: 12,
    textAlign: "center",
    fontSize: 18
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(250px, 1fr))",
    gap: 25
  },

  card: {
    background: "#fff",
    borderRadius: 18,
    overflow: "hidden",
    boxShadow:
      "0 4px 15px rgba(0,0,0,0.08)",
    transition: "0.3s",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer"
  },

  imageWrap: {
    height: 240,
    background: "#fafafa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 15
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  },

  noImage: {
    color: "#777",
    fontWeight: "bold"
  },

  info: {
    padding: 18,
    flex: 1
  },

  productName: {
    margin: 0,
    marginBottom: 10,
    fontSize: 18,
    color: "#222"
  },

  categoryText: {
    color: "#666",
    marginBottom: 10,
    fontSize: 14
  },

  price: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#ff5722",
    marginBottom: 10
  },

  stock: {
    fontSize: 14,
    fontWeight: "bold"
  },

 addBtn: {
  border: "none",
  background: "#ff9800",
  color: "#fff",
  padding: "18px",
  fontSize: "16px",
  fontWeight: "700",
  width: "100%"
},

buttonContainer: {
  display: "flex",
  flexDirection: "column",
  gap: 8
},

whatsappBtn: {
  border: "1px solid #25D366",
  background: "#fff",
  color: "#25D366",
  padding: "12px",
  fontSize: "14px",
  fontWeight: "600",
  width: "100%"
}
};